export default "__VITE_ASSET__463a5b53__"